import { css } from '@emotion/core';

// eslint-disable-next-line import/prefer-default-export
export const container = css`
  display: block;
  padding-bottom: 10px;
`;
